export default {
  hero_label: 'CONTACT',
  hero_title: 'Contact Us',
  hero_desc: 'For inquiries about AI strategy, DX promotion, AI talent development,\nand other AI-driven business transformation, please feel free to contact us.',
  what_label: 'WHAT WE CAN HELP',
  what_title: 'How We Can Help',
  help_1_title: 'AI Strategy Development',
  help_1_desc: 'Designing the optimal AI utilization strategy for your organization from scratch. End-to-end support from current state analysis to roadmap development.',
  help_2_title: 'DX Promotion & Execution Support',
  help_2_desc: 'Going beyond strategy development to accompany you through implementation and operations. We co-create a structure where your organization can operate independently.',
  help_3_title: 'AI Implementation & Business Reform',
  help_3_desc: 'Supporting productivity improvement through integrating AI into business processes and change management to promote internal transformation.',
  help_4_title: 'Data Utilization & Analytics Infrastructure',
  help_4_desc: 'Providing analytics infrastructure development and adoption support to leverage accumulated data for management and business decision-making.',
  form_label: 'INQUIRY FORM',
  form_title: 'Consultation & Inquiry Form',
  form_select_label: 'Please select your inquiry type',
  inquiry_service_label: 'Business & Service Inquiry',
  inquiry_service_desc: 'AI strategy, DX promotion, system development, etc.',
  inquiry_recruit_label: 'Job Application',
  inquiry_recruit_desc: 'Applications for open positions & career consultations',
  form_company: 'Company Name',
  form_company_ph: 'e.g. ABC Corporation',
  form_name: 'Full Name',
  form_name_ph: 'e.g. John Doe',
  form_email: 'Email Address',
  form_email_ph: 'e.g. john@company.com',
  form_phone: 'Phone Number',
  form_phone_ph: 'e.g. 03-0000-0000',
  form_services: 'Services of Interest',
  form_selected: 'Selected',
  form_message: 'Inquiry Details',
  form_message_ph: 'Please feel free to share your inquiries about AI utilization, DX promotion, or other needs.',
  form_chars: ' chars',
  form_submit: 'Submit',
  form_submitting: 'Sending...',
  form_submit_note: 'A representative will contact you within 3 business days after submission.',
  form_success: 'Your inquiry has been received. A representative will contact you within 3 business days.',
  form_error: 'Submission failed. Please check your input and try again.',
  err_company_required: 'Please enter your company name',
  err_email_invalid: 'Please enter a valid email address',
  err_message_required: 'Please enter your message',
  err_message_length: 'Please keep your message within 500 characters',
  err_name_required: 'Please enter your name',
  err_email_required: 'Please enter your email address',
  err_position_required: 'Please select a position to apply for',
  err_pr_required: 'Please enter your personal statement and motivation',
  err_pr_length: 'Please enter within 500 characters',
  recruit_banner: 'This is a recruitment entry form. After document screening, a representative will contact you regarding interview schedules. Please feel free to apply first.',
  form_position: 'Position to Apply For',
  form_employment_type: 'Preferred Employment Type',
  employment_types: ['Full-time', 'Freelance', 'Contract', 'Intern'],
  form_affiliation: 'Current Affiliation',
  form_affiliation_note: '(Current company or school name)',
  form_affiliation_ph: 'e.g. ABC Corporation / University of Tokyo',
  form_pr: 'Personal Statement & Motivation',
  form_pr_ph: 'Please share your experience, skills, and motivation for joining AIX JAPAN.',
  form_entry: 'Apply Now',
  form_entry_note: 'You will be contacted within one week regarding the document screening results.',
  recruit_success_title: 'Application Received',
  recruit_success: 'The document screening results will be sent to your registered email address within one week.',
};